export default __webpack_public_path__ + "static/media/banner-reaction-4.ad3815f9.jpg";